// @flow
import remote from 'app/api/remote';

const baseURL = 'https://www.fantasyinsider.com.au';

export async function getInsiderSport(sport: string): Promise<Object | undefined> {
  let slug = sport.toUpperCase();

  switch (sport) {
    case 'basketball':
      slug = 'NBA';
      break;
    case 'origin':
      slug = 'SOO';
      break;
    case 'rugby-league':
      slug = 'NRL';
      break;
    case 'american-football':
      slug = 'NFL';
      break;
    case 'cricket':
      // this case should be relevant only when smart lineup is enabled in the lineup builder
      slug = 'T20WC';
      break;
    case 'cricket-bb':
      slug = 'BIGBASH';
      break;
    case 'football':
      slug = 'SWC';
      break;
    case 'cricket-t20':
      slug = 'T20WC';
      break;
    default:
  }

  try {
    const data = await window.fetch(`${baseURL}/cruncher.json?sport=${slug}`);
    return data.json();
  } catch (err) {
    // console.log(err);
  }
  return undefined;
}

export async function crunchTeams(data) {
  return remote.post('lineups/optimizer', { data });
}
